import { useId, useRef, useState } from 'react';
import { Button } from '../../components/ui/Button.tsx';

/** Shows a freshly issued invite or sign-in link with a copy button. */
export function InviteLinkBox({ name, link }: { name: string; link: string }) {
  const id = useId();
  const input = useRef<HTMLInputElement>(null);
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
    } catch {
      // Clipboard blocked (e.g. plain http on a phone): select the text for a manual copy.
      input.current?.select();
    }
  }

  return (
    <div
      className="flex flex-col gap-2 rounded-md border border-success bg-success-tint p-3"
      role="status"
    >
      <label htmlFor={id} className="callout font-medium text-success">
        Invite link for {name}
      </label>
      <div className="flex gap-2">
        <input
          id={id}
          ref={input}
          readOnly
          value={link}
          data-testid="invite-link"
          onFocus={(e) => e.currentTarget.select()}
          className="min-h-10 min-w-0 flex-1 rounded-md border border-success bg-surface-raised px-2 font-mono footnote"
        />
        <Button variant="secondary" onClick={() => void copy()}>
          {copied ? 'Copied' : 'Copy'}
        </Button>
      </div>
      <p className="footnote text-success">
        Send it to them by text or email. It works once and expires after 24 hours; get a new one
        from the member list if needed. Testing it yourself? Open it in a private window: opening it
        here signs you out.
      </p>
    </div>
  );
}
